import React, { forwardRef } from 'react';
import propTypes from 'prop-types';

const LabelInput = forwardRef(
  (
    {
      type,
      inputValue = '',
      handleChange,
      label,
      errorMsg = null,
      className,
      onFocus,
      onBlur,
      onKeyUp,
      maxLength,
      minLength,
      disabled = false,
      required = false,
      isError = true,
      name,
      fullWidth = false,
      pattern,
      autoComplete = 'off',
      isPrefix,
      prefixText,
      min,
      max,
      isStarRequired,
      placeholder,
      hideLabel
    },
    ref
  ) => (
    <div className={fullWidth ? 'form-group full-width' : 'form-group'}>
      <input
        type={type}
        ref={ref}
        className={`form-control dis ${
          isPrefix ? 'prefix-text' : ''
        } ${className} ${fullWidth ? 'full-width' : ''}
        ${
            (required && required == 1) ?
                ((inputValue && String(inputValue).length) || (inputValue && String(inputValue).length)) ? '' : 'empty activeAnkInput' : ''
        }
        `}
        value={inputValue}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        maxLength={maxLength}
        minLength={minLength}
        min={min}
        max={max}
        disabled={disabled ? 'disabled' : ''}
        required={required ? 'required' : ''}
        name={name}
        pattern={pattern}
        autoComplete={autoComplete}
        placeholder={placeholder}
      />
        {!hideLabel &&
            <label className={`placeholder ${disabled ? 'labelDisable':''}`}>
                {label}{' '}
                {placeholder && (
                    <small>( {placeholder} )</small>
                )}
                {isStarRequired && (
                    <span className="label-star" style={{ color: 'red' }}>
            {' '}
                        *{' '}
          </span>
                )}
            </label>
        }

      {isPrefix && <span className="prefix">{prefixText}</span>}
      <label className={`error ${isError ? 'd-block' : ''}`}>{errorMsg}</label>
    </div>
  )
);

LabelInput.propTypes = {
  type: propTypes.oneOfType([propTypes.object, propTypes.string]),
  inputValue: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
    propTypes.number,
  ]),
  handleChange: propTypes.func,
  label: propTypes.oneOfType([propTypes.string, propTypes.object]),
  errorMsg: propTypes.oneOfType([propTypes.string, propTypes.object]),
  name: propTypes.oneOfType([propTypes.string, propTypes.object]),
};

export default LabelInput;
